// extracted by mini-css-extract-plugin
module.exports = {"root":"SMSInfo_root__3aaQx"};